import { createAction } from 'redux-actions';

export interface IPaymentToken {
	activePaymentToken: string;
}

export const setActivePaymentToken = createAction('SET_ACTIVE_PAYMENT_TOKEN', (action: IPaymentToken) => action);
